import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import MultiLineData from '../../../../components/Display/MultiLineData';
import styles from "../../cards.module.scss"

function PillsItem({ pills, handleClickPills, layout }) {

  console.log(pills);
  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGrid : ''}`}
      onClick={handleClickPills}>
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{pills.label}</p>
          <div className="flex flex-col gap-1">
            <MultiLineData key="description" value={pills.details} large asHtml />
          </div>
        </div>
        <div className={styles.tagList}>
          <Tag
            tag={{
              label: getConstant('quatrebis.pillsType', pills.type).label,
              bgColor: 'bg-sky-950'
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default PillsItem;
